import { render, staticRenderFns } from "./ChangeLogMoreTable.vue?vue&type=template&id=feebb35e&scoped=true"
import script from "./ChangeLogMoreTable.vue?vue&type=script&lang=js"
export * from "./ChangeLogMoreTable.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogMoreTable.vue?vue&type=style&index=0&id=feebb35e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feebb35e",
  null
  
)

export default component.exports